import PlaceholderImage from "components/utils/PlaceholderImage"
import React, { ReactNode } from "react"
import { LocationFood } from "styled-icons/zondicons"
import { BlurImage } from "types/firestore/productGroup"
import {
  BeforePrice,
  DiscountBadge,
  Price,
  ProductDesc,
  ProductImagePlaceholder,
  ProductImageWrapper,
  ProductItemWrapper,
  ProductMeta,
  ProductMetaWrapper,
  ProductPriceWrapper,
  ProductTitle,
  Unit,
} from "./styles/ProductItemStyles"

interface ProdImgPlaceholderProps {
  loading?: boolean
  small?: boolean
}

const _ProdImgPlaceholder = ({ loading, small = false }: ProdImgPlaceholderProps) => {
  return (
    <ProductImagePlaceholder load={loading} small={small}>
      <LocationFood />
    </ProductImagePlaceholder>
  )
}

export const ProdImgPlaceholder = React.memo(_ProdImgPlaceholder)

interface ProductItemProps {
  image?: BlurImage
  title?: string
  desc: string | ReactNode
  beforePrice?: number | string
  price?: number | string
  unit?: string
  onClick?: () => void
  descOverflow?: boolean
  soldOut?: boolean
  loading?: boolean
  discountRate?: number
  inventoryNotice?: string
  basePrice?: string
}

const ProductTile = ({
  image,
  title,
  desc,
  beforePrice,
  price,
  unit,
  onClick,
  descOverflow = true,
  soldOut,
  loading,
  discountRate,
  inventoryNotice = "",
  basePrice,
}: ProductItemProps) => {
  return (
    <ProductItemWrapper onClick={onClick || (() => undefined)} disabled={soldOut || loading} load={loading}>
      {image ? (
        <ProductImageWrapper>
          <PlaceholderImage
            src={image}
            alt="Produktbild"
            layout="fixed"
            width={70}
            height={70}
            objectFit="cover"
            objectPosition="50% 50%"
          />
        </ProductImageWrapper>
      ) : (
        <ProdImgPlaceholder loading={loading} />
      )}
      {!loading && (
        <ProductMetaWrapper>
          <ProductMeta>
            {!loading && inventoryNotice ? <ProductDesc oneLine={descOverflow}>{inventoryNotice}</ProductDesc> : null}
            <ProductTitle>{title}</ProductTitle>

            <ProductDesc oneLine={descOverflow}>{desc}</ProductDesc>
          </ProductMeta>
          {(price || price === 0) && unit && (
            <ProductPrice
              beforePrice={beforePrice}
              price={price}
              unit={unit}
              discountRate={discountRate}
              withUnit={unit !== "Stück" && unit !== "piece"}
              basePrice={basePrice}
            />
          )}
        </ProductMetaWrapper>
      )}
    </ProductItemWrapper>
  )
}

interface ProductPriceProps {
  beforePrice?: number | string
  price: number | string
  unit?: string
  currency?: "€"
  withUnit?: boolean
  discountRate?: number
  basePrice?: string
}

const _ProductPrice = ({
  beforePrice,
  price,
  unit,
  currency = "€",
  withUnit = true,
  discountRate,
  basePrice,
}: ProductPriceProps) => {
  const hasStrikePrice = !!discountRate
  return (
    <ProductPriceWrapper>
      <Price>
        {beforePrice && <BeforePrice>{beforePrice}</BeforePrice>}
        {price} {currency}
      </Price>
      {withUnit && <Unit>{unit}</Unit>}
      {hasStrikePrice && <DiscountBadge>- {discountRate}%</DiscountBadge>}
      {basePrice && <BeforePrice>{basePrice}</BeforePrice>}
    </ProductPriceWrapper>
  )
}

export const ProductPrice = React.memo(_ProductPrice)

export default React.memo(ProductTile)
